export default {
  header: {
    notifications: '消息通知',
    language: '语言',
    zhCN: '简体中文',
    en: '英文',
    newChat: '新对话',
  },
  headerNotification: {
    title: '通知与告警',
    noUnread: '暂无未读消息',
    unreadSummary: '{count} 条未读消息',
    emptyTab: '暂无此类消息',
    viewAll: '查看全部通知',
    sourceXiaoyuClaw: 'XiaoyuClaw',
  },
  common: {
    ok: '知道了',
    confirm: '确定',
    cancel: '取消',
    delete: '删除',
    times: '次',
    collapse: '收起',
    expand: '展开',
    loading: '加载中...',
    noData: '暂无数据',
    search: '搜索',
    experimental: '实验性',
  },
  platformNav: {
    workspace: '智能工作台',
    assistant: 'AI助手',
    experts: 'AI员工',
    resources: '资源库',
    skills: '技能库',
    connectors: '连接器',
    knowledge: '知识库',
    automation: '自动流',
    apps: '应用集',
    dev: 'AI开发',
    comingSoon: '该模块正在建设中，后续版本将按新设计逐步完善。',
    help: '帮助',
  },
  devPage: {
    subtitle: '进入数据底座与 Agent 编排进行开发工作。',
    datahub: '数据底座',
    datahubDesc: '管理业务数据模型、表结构与数据内容。',
    studio: 'Agent 编排',
    studioDesc: '编排智能体、模型与运行时配置。',
    noAccess: '当前账号暂无开发工具权限，请联系管理员开通。',
    back: '返回',
    exit: '退出',
    connecting: '正在接入',
    connectingHint: '工作台正在打开嵌入应用。',
    embedTimeout: '接入超时，请退出后重试。',
  },
  resourcesPage: {
    subtitle: '统一管理技能库、连接器与知识库。',
    tabs: {
      skills: '技能库',
      connectors: '连接器',
      knowledge: '知识库',
    },
  },
  automation: {
    subtitle: '让AI助手、AI员工或脚本按照计划自动执行任务。',
    create: '新建自动流',
    createDesc: '选择执行者、编写任务提示词并设置调度周期。',
    tabs: {
      assistant: 'AI助手',
      expert: 'AI员工',
      script: '脚本',
      assistantHint: 'AI助手自动流在你的专属实例里运行。',
      expertHint: 'AI员工自动流由平台调度执行，并通过回调异步返回结果。',
      scriptHint: '脚本自动流在平台的一次性隔离容器中按 cron 计划运行，不依赖实例在线。',
    },
    running: '运行中',
    total: '全部任务',
    executedTotal: '累计执行',
    monthlyExecutions: '本月执行',
    successRate: '成功率',
    columns: {
      taskName: '任务名称',
      lastRunTime: '最近一次运行时间',
      executedCount: '已执行次数',
      abnormalCount: '异常次数',
      status: '运行状态',
      actions: '操作',
      detail: '运行详情',
      agentName: '智能体',
      nextRun: '下次运行',
      content: '执行内容',
    },
    executorBadge: {
      assistant: 'AI助手',
      script: '脚本',
    },
    viewDetail: '查看详情',
    noLastRun: '暂无运行',
    noAbnormalData: '0',
    empty: {
      assistant: '还没有AI助手自动流任务，点击右上角「新建自动流」创建。',
      expert: '还没有智能体自动流任务，点击右上角「新建自动流」创建。',
      script: '还没有脚本自动流任务，点击右上角「新建自动流」创建。',
    },
    status: {
      running: '运行中',
      completed: '已完成',
      paused: '已暂停',
      waiting: '等待执行',
      terminated: '已终止',
      abnormal: '异常',
      humanIntervention: '等待人工介入',
    },
    actions: {
      pauseRun: '暂停运行',
      resumeRun: '恢复运行',
      stopTask: '终止任务',
      restartTask: '重启任务',
      deleteTask: '任务删除',
      intervene: '人工介入',
      viewRuns: '运行记录',
      delete: '删除',
      pause: '暂停',
      resume: '恢复',
    },
    runsTitle: '运行记录：{name}',
    runTime: '执行时间',
    runStatus: '执行状态',
    runSummary: '执行简报',
    runDuration: '执行时长',
    noRuns: '暂无运行记录',
    scriptUploadFailed: '任务已创建，但脚本包上传失败：{reason}',
    runScriptStatus: {
      running: '运行中',
      success: '成功',
      failed: '失败',
      timeout: '超时',
    },
    scriptLog: {
      output: '标准输出',
      error: '错误输出',
      empty: '暂无日志',
    },
    artifacts: {
      title: '运行产物',
      empty: '本次运行没有产物',
      view: '查看',
      download: '下载',
      kindReport: '报告',
      kindFile: '文件',
      badge: '产物 {count}',
      loadFailed: '产物加载失败：{reason}',
      viewerTitle: '产物预览：{name}',
    },
  },
  apps: {
    title: '应用',
    systemPrompt: '你现在是 Apps 的开发者模式助手。用户正在通过自然语言迭代开发一个多页面 HTML/JS/CSS 应用。规则如下：\n1. 当前应用是 "{appName}"，当前页面是 "{pageName}"。当用户要求创建或修改页面时，请在回复中直接提供完整、可独立运行的 HTML，放在 ```html ... ``` 代码块里。\n2. 前端会自动把代码块中的 HTML 保存到当前页面，不需要你把文件写入磁盘，也不需要调用 canvas 工具。\n3. 如果用户想创建新页面，请提示他们使用左侧的「添加页面」按钮。\n4. 每个页面的 HTML 应该是完整文档或可以嵌入文档的片段。',
    runtimeSystemPrompt: '当前是运行型轻应用 "{appName}"（app_id: {appId}），它能在轻量容器里构建并运行。请使用你已加载的 `light-app-dev` 技能来开发它：把完整的多文件工程写到 `workspace/apps/{appId}/`，写完后调用 app_run 工具让它在容器里构建并启动。技能里有完整的工程结构 / manifest / 运行指引。完成后简要说明工程结构与如何预览。',
    packageSystemPrompt: '当前是打包轻应用 "{appName}"（app_id: {appId}），它是一个 zip 打包的静态轻应用。规则如下：\n1. 用 write 工具在你的工作区下把要修改/新增的文件写到 `apps/{appId}/` 目录（例如 index.html、style.css、app.js 等）。\n2. 平台会把这些文件同步到应用的包里，预览即更新。不要只回单段 HTML。\n3. 完成后简要说明改了哪些文件。',
    overview: {
      title: '应用',
      subtitle: '个人应用由你自己开发维护，可提交审核；企业应用由管理员审批后发布。',
      create: '创建应用',
      upload: '上传轻应用',
      searchPlaceholder: '搜索应用',
      personal: '个人应用',
      org: '企业应用',
      reviewing: '审核中',
      empty: {
        personal: '暂无个人应用，点击右上角「创建应用」开始。',
        org: '暂无企业应用。',
        reviewing: '暂无审核中的应用。',
      },
    },
    card: {
      open: '打开应用 →',
      personalBadge: '个人',
      orgBadge: '企业',
      reviewingBadge: '审核中',
      packageBadge: '打包',
      agentBadge: 'Agent',
      pages: '{count} 个页面',
      version: 'v{version}',
      kindStatic: '静态页面',
      kindRuntime: '容器动态',
    },
    detail: {
      back: '应用',
      share: '分享审批',
      sharePending: '审核中',
      vibeCoding: '打开 Vibe Coding',
      vibeCodingClose: '关闭 Vibe Coding',
      reupload: '上传新版本',
      downloadSource: '下载源码',
      agentUploadLink: 'Agent 上传链接',
      more: '更多',
      publishPackage: '发布为轻应用',
    },
    runtime: {
      run: '运行',
      stop: '停止运行',
      started: '已启动运行容器',
      starting: '启动中…',
      startFailed: '启动运行容器失败：{message}',
      stopped: '已停止运行容器',
      stopFailed: '停止运行容器失败：{message}',
      timeout: '容器启动超时，请重试',
      buildFailed: '构建失败（退出码 {code}），请查看构建日志',
      status: {
        starting: '启动中',
        building: '构建中',
        running: '运行中',
        stopped: '已停止',
        error: '错误',
      },
      notRunningHint: '应用未运行，点击右上角「运行」启动',
      buildingHint: '正在构建并启动…',
      viewBuildLogs: '查看构建日志',
      viewRunLogs: '查看运行日志',
      buildLogs: '构建日志',
      runLogs: '运行日志',
      logsEmpty: '暂无日志',
      logsLoadFailed: '读取日志失败',
    },
    editor: {
      open: '编辑文件',
      close: '关闭编辑',
      openReadonly: '查看文件',
      readonlyBadge: '只读',
      files: '文件',
      newFile: '新文件',
      newFilePrompt: '输入文件路径（含扩展名，如 about.html、css/app.css）',
      newFileInvalid: '文件名需包含扩展名',
      newFolder: '新文件夹',
      newFolderPrompt: '输入文件夹路径（如 assets、js）',
      newFolderInvalid: '文件夹路径不能为空',
      rename: '重命名',
      renamePrompt: '输入新的路径',
      delete: '删除',
      deleteConfirm: '确定删除「{path}」吗？删除后无法恢复。',
      save: '保存',
      saved: '已保存 {path}',
      saveFailed: '保存失败：{message}',
      created: '已创建 {path}',
      renamed: '已重命名为 {path}',
      deleted: '已删除 {path}',
      loadFailed: '加载失败：{message}',
      versions: '版本',
      snapshot: '保存为新版本',
      snapshotPrompt: '为新版本命名（留空则自动递增）',
      snapshotPlaceholder: '如 1.0.1',
      snapshotted: '已保存为新版本 v{version}',
      rollback: '回滚',
      rollbackTo: '回滚到 v{version}',
      rollbackConfirm: '回滚到 v{version}？当前未保存的修改将保留在新版本中，激活版本会切换到 v{version}。',
      rolledBack: '已回滚到 v{version}',
      noSelection: '未选择文件',
      selectHint: '选择左侧的文件开始编辑',
      binaryNote: '二进制文件，仅可查看，暂不支持编辑',
      emptyFiles: '暂无文件',
    },
    address: {
      title: 'Agent 上传链接',
      hint: '生成一条带凭证的上传链接，复制后交给外部 Agent；它把 zip 轻应用 POST 到该链接即上传到你名下。链接 1 小时内有效。',
      generate: '生成',
      copy: '复制',
      copied: '已复制',
      regenerate: '重新生成',
      expiresAt: '有效期至 {time}',
    },
    agentLink: {
      title: 'Agent 上传链接（仅本应用）',
      hint: '生成一条仅作用于当前轻应用的上传链接，复制后交给外部 Agent。它把 zip 上传到该链接即为当前应用新增一个版本，并用 app.json 覆盖应用元数据（名称 / 描述）。链接 1 小时内有效。',
      generate: '生成',
      copy: '复制',
      copied: '已复制',
      regenerate: '重新生成',
      expiresAt: '有效期至 {time}',
    },
    pageList: {
      title: '业务网页',
      add: '添加页面',
      rename: '重命名',
      delete: '删除',
      empty: '暂无页面',
      importPaste: '粘贴 HTML 代码',
      importFile: '从 HTML 文件导入',
      importPastePrompt: '粘贴完整的 HTML 代码（含 <!DOCTYPE> 或 <html>）',
      importPasteEmpty: 'HTML 代码不能为空',
    },
    preview: {
      browserUrl: '页面地址',
      empty: '选择一个页面以预览',
      refresh: '刷新',
      fullscreen: '全屏',
      exitFullscreen: '退出全屏',
      openFull: '整页打开',
    },
    fullView: {
      notFound: '应用不存在或无权访问',
      empty: '该页面还没有内容，请先在 Vibe Coding 中生成',
    },
    dialog: {
      createTitle: '创建应用',
      createPlaceholder: '请输入应用名称',
      renameTitle: '重命名应用',
      renamePlaceholder: '请输入新的应用名称',
      pageCreateTitle: '添加页面',
      pageCreatePlaceholder: '请输入页面名称',
      pageRenameTitle: '重命名页面',
      pageRenamePlaceholder: '请输入新的页面名称',
    },
    confirm: {
      deleteApp: '确定删除应用 "{name}" 吗？删除后无法恢复。',
      deletePage: '确定删除页面 "{name}" 吗？删除后无法恢复。',
      publishPackage: '将「{name}」打包发布为轻应用？原应用保留，会生成一个新的打包轻应用。',
    },
    toast: {
      created: '应用 "{name}" 创建成功',
      createFailed: '创建应用失败：{message}',
      renamed: '应用已重命名为 "{name}"',
      renameFailed: '重命名应用失败：{message}',
      deleted: '应用 "{name}" 已删除',
      deleteFailed: '删除应用失败：{message}',
      shared: '应用 "{name}" 已提交审核',
      shareFailed: '提交审核失败：{message}',
      pageCreated: '页面 "{name}" 创建成功',
      pageCreateFailed: '创建页面失败：{message}',
      pageRenamed: '页面已重命名为 "{name}"',
      pageRenameFailed: '重命名页面失败：{message}',
      pageDeleted: '页面 "{name}" 已删除',
      pageDeleteFailed: '删除页面失败：{message}',
      pageSaveFailed: '保存页面失败：{message}',
      pageRenderFailed: '渲染页面失败：{message}',
      pageImported: '页面 "{name}" 已导入',
      loadFailed: '加载失败：{message}',
      uploaded: '轻应用 "{name}" 上传成功',
      uploadedWithWarnings: '上传成功，但有告警：{warnings}',
      versionUploaded: '应用 "{name}" 已更新到 v{version}',
      uploadFailed: '上传轻应用失败：{message}',
      linkGenerated: '上传链接已生成并复制',
      linkGenerateFailed: '生成上传链接失败：{message}',
      publishedAsPackage: '已将「{name}」发布为轻应用',
      publishFailed: '发布为轻应用失败：{message}',
      workspaceSynced: '工作区文件已同步到应用',
    },
  },
  expertsPage: {
    subtitle: '企业根据你的角色配置的专业智能体。',
    searchPlaceholder: '搜索智能体',
    favorite: '收藏',
    favorited: '已收藏',
    like: '点赞',
    liked: '已点赞',
    orgConfigured: '企业配置',
    usesCount: '{count} 次使用',
    noRating: '暂无',
    rate: '评价',
    rated: '已评价',
    startChat: '开始对话 →',
    empty: '没有找到匹配的智能体',
    noDescription: '暂无描述',
    externalAgentTip: '该智能体为外部智能体，请扫描二维码访问',
    startChatFailed: '打开智能体对话失败，请稍后重试',
    favoriteFailed: '收藏操作失败，请稍后重试',
    likeFailed: '点赞操作失败，请稍后重试',
    tabs: {
      all: '全部',
      favorite: '收藏',
    },
    sortLabel: '排序',
    sort: {
      createTime: '创建时间',
      lastChatTime: '使用时间',
      usageCount: '使用次数',
    },
  },
  assistantPage: {
    title: 'AI助手',
    subtitle: '你的个人 AI 助理 · 可调用文件、技能库与企业资源',
    notLoggedIn: '未登录，请先登录后再使用AI助手。',
    instanceStarting: '正在启动，请稍候…',
    loadingOlder: '正在加载更早的消息…',
    emptyTitle: '有什么可以帮你？',
    emptyHint: '描述你想完成的工作，AI助手会根据需要使用已授权的知识、技能库和连接器。',
    inputPlaceholder: '输入任务或问题，Enter 发送，Shift + Enter 换行',
    skill: '技能库',
    knowledge: '知识',
    personalKnowledge: '个人知识库',
    orgKnowledge: '企业知识库',
    connector: '连接器',
    addResource: '添加资源',
    skillsTab: '技能',
    connectorsTab: '连接器',
    use: '使用',
    enabled: '已启用',
    disabled: '已禁用',
    enable: '启用',
    disable: '禁用',
    noSkills: '暂无技能',
    noConnectors: '暂无连接器',
    personalMcpTag: '个人',
    modelPlaceholder: '选择模型',
    skillLabel: '使用技能：',
    attachFile: '从本地选择文件',
    dropToAttach: '松开鼠标，添加为附件',
    stop: '停止',
    send: '发送',
    disclaimer: 'AI 生成内容仅供参考，请核对重要信息',
    instanceNotReady: '实例未就绪，正在重新确认实例状态...',
    instanceNotRunning: '实例未运行，无法发送消息',
    stopped: '已停止',
    retrying: '重连网络中（{attempt}/{max}）',
    retryFailed: '重连失败，请检查网络后重试',
    resend: '重新发送',
    networkStalled: '网络连接中断，输出已停止，请检查网络后重试',
    sendFailed: '发送失败：{reason}',
    turnLimit: '并发对话轮次已达上限，请等待当前轮次结束后再试。',
    streamError: 'Stream error',
    noContent: '(no content)',
    thinking: '思考中',
    reasoning: '思考过程',
    showThinkingTools: '显示思考过程与工具调用',
    hideThinkingTools: '隐藏思考过程与工具调用',
    skillPrompt: '请使用“{name}”技能协助我：',
    createSkillPrompt: '请帮我创建一个技能：',
    toolCalls: '工具调用',
    toolRunning: '执行中',
    toolDone: '已完成',
    toolInterrupted: '已中断',
    toolInput: '输入',
    toolOutput: '输出',
    requireInstance: '请先登录并启动AI助手实例',
    attachLabel: '附件（已上传到实例，供AI助手读取）：',
    attachFailed: '附件上传失败：{reason}',
    connectorSyncFailed: '连接器同步失败：{reason}',
    knowledgeSyncFailed: '知识库选择同步失败：{reason}',
    knowledgeRetrievalHint:
      '用户为本轮对话选择了知识库（dataset_ids: {ids}）。当问题需要这些知识库的内容时，请调用 ragflow_retrieval 工具，且仅使用这些 dataset_ids 进行检索，并优先依据检索到的内容作答、标注来源；与知识库无关的问题无需检索。',
    echartsHint:
      '你的回复支持图表渲染：当需要展示数据对比、趋势、占比等图表时，必须在回复正文中输出一个 echarts 代码块（```echarts 围栏，内容为单个合法 JSON 对象，即 ECharts 的 option，含 title/xAxis/yAxis/series 等字段），前端会将其渲染为交互式图表。禁止用 canvas/write 类工具写 HTML 图表文件再发 [embed] 标签——那种图表在对话里渲染不出来，唯一的图表输出方式就是 echarts 代码块。代码块外仍用正常文字说明；不要把 option 拆成多个代码块。',
    mentionSearchPlaceholder: '搜索所选知识库中的文件…',
    mentionNoKnowledge: '请先在下方选择知识库，再 @ 引用其中的文件',
    mentionNoFiles: '没有匹配的文件',
    mentionRetrievalHint:
      '用户在本轮对话中引用了以下知识库文件：\n{files}\n回答相关问题前，请调用 ragflow_retrieval 工具并传入对应的 document_ids（可同时传 dataset_ids）精确检索这些文件，优先依据检索到的内容作答。',
    workspaceHint:
      '本会话绑定了项目工作区「{name}」，工作目录为 {dir}（绝对路径 /home/node/.openclaw/{dir}）。请把本会话中创建或修改的文件都保存在该目录下。',
    workspacePanel: {
      title: '工作区',
      selectPlaceholder: '选择工作区…',
      createNew: '新建工作区',
      createPrompt: '工作区名称',
      createRequired: '名称不能为空',
      createSuccess: '工作区已创建',
      rename: '重命名',
      renameSuccess: '已重命名',
      delete: '删除工作区',
      deleteTip: '删除工作区「{name}」会解除所有会话的绑定，但不会删除目录中的文件。确定删除吗？',
      deleteSuccess: '工作区已删除',
      unbind: '解除绑定',
      bindSuccess: '已绑定工作区',
      unbindSuccess: '已解除绑定',
      unboundTitle: '当前会话未绑定工作区',
      unboundDesc: '绑定后，本会话上传的附件会进入工作区目录；绑定同一工作区的多个会话共享这些文件。',
      pendingBindHint: '将在发送首条消息后自动绑定到当前会话',
      refresh: '刷新',
      loadFailed: '加载工作区失败',
    },
  },
  skillsPage: {
    subtitle: '使用个人与企业技能；可通过AI助手生成或从本地安装技能包。',
    installPackage: '本地安装技能包',
    createByAssistant: '通过AI助手创建技能',
    scopePersonal: '个人技能',
    scopeOrg: '企业技能',
    review: '评价',
    ratingPlaceholder: '评分（即将上线）',
    likePlaceholder: '收藏（即将上线）',
    reviewPlaceholder: '评价（即将上线）',
    mySkills: '我的技能',
    mySkillsHint: '可使用并分享至管理平台',
    orgSkills: '企业技能',
    orgSkillsHint: '由管理员按角色授权',
    reviewing: '审核中',
    reviewingHint: '管理平台审核后按角色分发',
    mySkillsSection: 'AI助手为你生成的个人技能',
    orgSkillsSection: '管理员为当前角色授权的功能技能',
    personalAvailable: '个人可用',
    roleAuthorized: '角色授权',
    use: '使用',
    useLoading: '准备中...',
    share: '分享',
    shareSubmitting: '提交中...',
    shareSubmitted: '已提交管理员审核，审核通过后将进入企业技能',
    shareFailed: '分享失败：{reason}',
    submitted: '已提交',
    tabAll: '全部',
    tabInstalled: '已安装',
    searchPlaceholder: '搜索技能名称、描述或标签',
    install: '安装',
    installLoading: '安装中...',
    uninstall: '卸载',
    uninstallLoading: '卸载中...',
    installedBadge: '已安装',
    versionsCount: '{count} 个版本',
    downloadsUnit: '次下载',
    usageUnit: '次使用',
    availablePersonal: '个人可用',
    availableOrg: '企业可用',
    loading: '加载技能库中...',
    emptyAll: '没有找到可用的技能包',
    emptyInstalled: '当前实例尚未安装任何技能',
    emptySearch: '没有匹配的技能',
    uploadFailed: '技能包上传失败：{reason}',
    uploadPendingReview: '技能包已提交，等待管理员审核后分发',
    requireInstance: '请先登录并启动AI助手实例后再管理技能',
    loadDetailFailed: '加载技能详情失败：{reason}',
    installFailed: '安装失败：{reason}',
    uninstallFailed: '卸载失败：{reason}',
    listInstalledFailed: '获取已安装技能失败，仅展示全部技能',
    detailTitle: '技能详情',
    detailCategory: '分类',
    detailVersion: '版本',
    detailAuthor: '作者',
    detailDownloads: '下载量',
    detailCreatedAt: '上传时间',
    detailFormat: '打包格式',
    detailTags: '标签',
    detailInstructions: '使用说明',
    detailRequirements: '运行依赖',
    detailBins: '可执行文件',
    detailEnv: '环境变量',
    detailPlatforms: '支持平台',
    detailHomepage: '主页',
    detailShare: '复制分享链接',
    detailShareCopied: '已复制',
    detailDownload: '下载原包',
    packageTitle: '安装本地技能包',
    packageDesc: '技能将部署到“我的技能”，仅当前用户可用。',
    packageChooseFile: '选择技能包文件',
    packageFileHint: '支持 .zip、.tar.gz，可多选；单个压缩包可包含多个技能（任意目录层级），名称与版本自动从 SKILL.md 解析',
    packageInstall: '安装技能',
    packageSecurityNote: '安装前将校验技能包结构和安全策略，不会自动分享到企业。',
    packageNoFile: '请先选择技能包文件',
    packageSuccess: '技能包已提交，正在安装到当前实例',
    packageFilesChosen: '已选 {count} 个文件',
    packageResultsTitle: '解析结果',
    packagePartialFailed: '部分技能未能注册或安装，请查看解析结果',
    packageNoneRegistered: '未能注册任何技能',
    personalEmpty: '还没有个人技能，可通过AI助手生成或从本地上传。',
    orgEmpty: '管理员尚未为当前角色授权企业技能。',
    reviewEmpty: '当前没有审核中的技能。',
  },
  connectorsPage: {
    subtitle: '查看企业授权可用的 MCP 服务器连接器。',
    orgWorkbench: '企业工作台',
    loading: '加载连接器中...',
    authorized: '企业授权',
    viewPermission: '查看权限',
    empty: '当前没有可用的企业连接器。',
    loadFailed: '连接器列表获取失败：{reason}',
    statusActive: '可用',
    statusError: '不可用',
    statusDisabled: '已禁用',
    detailTitle: '连接器详情',
    detailTransport: '传输方式',
    detailStatus: '状态',
    detailProvider: '提供方',
    detailToolCount: '工具数量',
    toolsUnit: '个可用工具',
    detailCommand: '启动命令',
    detailUrl: '服务地址',
    detailTools: '可用工具',
    noTools: '暂无工具',
    loadDetailFailed: '加载详情失败：{reason}',
    myMcpTitle: '我的 MCP',
    myMcpHint: '添加自己的 MCP 服务器，创建即生效，仅你可用。',
    addMcp: '添加 MCP',
    orgSectionTitle: '企业连接器',
    myMcpEmpty: '还没有个人 MCP 服务器，点击右上角「添加 MCP」接入你的工具服务。',
    myMcpLoadFailed: '个人 MCP 列表获取失败：{reason}',
    mcpAuthDirect: '直连',
    mcpAuthPlatform: '平台鉴权',
    mcpHeadersCount: '{count} 个自定义请求头',
    mcpTest: '测试连接',
    mcpTesting: '测试中...',
    mcpEdit: '编辑',
    mcpDelete: '删除',
    mcpDeleteTitle: '删除 MCP 服务器',
    mcpDeleteConfirm: '确定删除 MCP 服务器「{name}」吗？删除后将从你的实例中移除，无法恢复。',
    mcpDeleted: '已删除',
    mcpDeleteFailed: '删除失败：{reason}',
    mcpSaved: '已保存',
    mcpSaveFailed: '保存失败：{reason}',
    mcpTestOk: '连接成功，发现 {count} 个工具',
    mcpTestFailed: '连接测试失败：{reason}',
    mcpDialog: {
      createTitle: '添加 MCP 服务器',
      editTitle: '编辑 MCP 服务器',
      name: '名称',
      namePlaceholder: '请输入名称，例如：我的文档服务',
      url: '服务地址（URL）',
      urlPlaceholder: 'https://example.com/mcp',
      urlInvalid: '请输入以 http:// 或 https:// 开头的服务地址',
      description: '描述',
      descriptionPlaceholder: '可选，说明这个服务提供什么能力',
      platformAuth: '使用智能体平台鉴权',
      platformAuthHint: '开启后，实例通过平台代理调用该服务，并把当前用户的平台令牌（Authorization: Bearer）注入请求头，服务可直接用 YY 用户身份鉴权；不开启则直连端点、不携带平台凭据。',
      headers: '自定义请求头',
      headersHint: '请求头由平台代理在服务端注入，不会下发到你的实例。',
      headerKey: 'Header 名',
      headerValue: 'Header 值',
      addHeader: '添加请求头',
      confirm: '保存',
    },
  },
  knowledgePage: {
    publicReadonlyTip: '公共知识库为只读，可在对话中使用',
    subtitle: '管理个人知识，使用企业公共知识。',
    create: '创建知识库',
    personalSection: '我的知识库',
    personalSectionHint: '可上传、查看、下载和删除文件',
    publicSection: '公共知识库',
    publicSectionHint: '由管理平台按角色配置，只可使用',
    readonly: '只读',
    loading: '加载知识库中...',
    personalEmpty: '还没有个人知识库，点击上方按钮创建。',
    publicEmpty: '管理员尚未为当前角色配置公共知识库。',
    createFailed: '创建知识库失败：{reason}',
    loadFailed: '知识库列表获取失败：{reason}',
    filesLabel: '{count} 个文档',
    updatedLabel: '更新于 {time}',
    createDialog: {
      title: '创建知识库',
      desc: '用于沉淀个人资料、文档与研究。',
      name: '名称',
      namePlaceholder: '请输入名称',
      description: '描述',
      descriptionPlaceholder: '请输入用途说明',
      confirm: '创建',
    },
  },
  automationPage: {
    subtitle: '让AI助手或智能体按照计划自动执行任务。',
    create: '新建自动流',
    running: '运行中',
    monthlyExecutions: '本月执行',
    successRate: '成功率',
    loading: '加载自动流中...',
    empty: '还没有自动流任务，点击上方按钮新建。',
    loadFailed: '自动流列表获取失败：{reason}',
    createFailed: '创建自动流失败：{reason}',
    table: {
      name: '任务名称',
      lastRun: '最近一次运行',
      executions: '已执行次数',
      exceptions: '异常次数',
      status: '运行状态',
      actions: '操作',
      details: '运行详情',
    },
    statusRunning: '运行中',
    statusCompleted: '已完成',
    statusPaused: '已暂停',
    statusNeedsInput: '等待人工介入',
    createDialog: {
      title: '新建自动流',
      desc: '选择执行者、编写任务提示词并设置调度周期。',
      name: '自动流名称',
      namePlaceholder: '例如：每周项目进展汇总',
      executor: '执行者',
      executorAssistant: 'AI助手',
      executorAssistantHint: '使用AI助手当前可用的知识与工具',
      executorExpert: 'AI员工',
      executorExpertHint: '调用指定AI员工及其授权能力',
      expertSelect: '选择智能体',
      prompt: '任务提示词',
      promptPlaceholder: '清晰描述自动流要完成的任务、需要读取的信息和期望输出',
      promptHint: '支持引用日期、用户和运行时间等变量。',
      schedule: '调度周期',
      scheduleDaily: '每天',
      scheduleWeekly: '每周',
      scheduleMonthly: '每月',
      scheduleWorkday: '工作日',
      scheduleCustom: '自定义',
      time: '执行时间',
      timezone: '时区',
      startDate: '开始日期',
      notify: '运行完成后向我发送通知',
      previewPrefix: '预计下次运行：',
      confirm: '创建自动流',
    },
  },
  userSettings: {
    title: '用户设置',
    editContact: '修改联系方式',
    accountSecurity: '账号与安全',
    defaultName: '用户',
    defaultDepartment: '未设置部门',
  },
  aside: {
    logoTitle: '智能体工作台',
    myAgents: '我的智能体',
    more: '更多',
    collapse: '收起',
    historyConversations: '历史对话',
    assistantConversations: 'AI助手对话',
    expertConversations: '智能体对话',
    searchHistoryConversations: '搜索历史对话',
    searchAssistantConversations: '搜索AI助手对话',
    searchExpertConversations: '搜索智能体对话',
    newAssistantConversation: '新建AI助手对话',
    assistantFiles: 'AI助手文件',
    workspaceTitle: 'AI助手文件',
    workspaceSubtitle: 'AI 助理工作目录',
    uploadFile: '上传文件',
    createFolder: '新建文件夹',
    allFiles: '全部文件',
    goUp: '返回上一级',
    folder: '文件夹',
    loadingFiles: '加载中…',
    noFiles: '暂无文件',
    folderNamePlaceholder: '请输入文件夹名称',
    folderNameRequired: '文件夹名称不能为空',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    createFolderSuccess: '文件夹创建成功',
    loadFilesFailed: '加载文件列表失败',
    preview: '预览',
    download: '下载',
    renameFileTitle: '重命名',
    renameFilePlaceholder: '请输入新名称',
    renameFileRequired: '名称不能为空',
    renameFileSuccess: '重命名成功',
    renameFileFailed: '重命名失败',
    deleteFileTitle: '删除文件',
    deleteFileTip: '确定要删除「{name}」吗？删除后不可恢复。',
    deleteFileSuccess: '删除成功',
    deleteFileFailed: '删除失败',
    downloadFailed: '下载失败',
    previewLoading: '正在加载预览…',
    previewFailed: '预览加载失败',
    previewUnsupported: '此格式暂不支持在线预览，可下载后查看',
    newExpertConversation: '选择智能体后新建对话',
    selectExpertFirst: '请先选择要对话的智能体',
    emptyAssistantConversations: '暂无AI助手对话',
    emptyExpertConversations: '暂无智能体对话',
    untitledConversation: '未命名对话',
    noSearchResults: '未找到匹配的对话',
    moreActions: '更多操作',
    workspaces: '工作区',
    newWorkspace: '新建工作区',
    workspaceNamePlaceholder: '请输入工作区名称',
    workspaceNameRequired: '工作区名称不能为空',
    workspaceCreateSuccess: '工作区创建成功',
    workspaceActionFailed: '操作失败，请稍后重试',
    newChatInWorkspace: '在工作区新建对话',
    renameWorkspace: '重命名工作区',
    deleteWorkspaceTitle: '删除工作区',
    deleteWorkspaceTip: '删除「{name}」后，对话将解除绑定，工作区文件会保留。',
    past7Days: '过去 7 天',
    earlier: '更早',
    loadingConversations: '加载历史对话中...',
    emptyConversations: '暂无历史对话',
    emptyConversationRecords: '暂无对话记录',
    myTasks: '我的任务',
    loadingTasks: '加载任务中...',
    emptyTasks: '暂无任务',
    newConversation: '新建对话',
    newTask: '新建任务',
    today: '今天',
    yesterday: '昨天',
    theDayBeforeYesterday: '前天',
    waiting: '等待执行',
    running: '运行中',
    paused: '已暂停',
    terminated: '已终止',
    completed: '已完成',
    humanIntervention: '邀请人工',
    abnormal: '异常',
    pleaseSelectAgent: '请先选择智能体',
    agentNotFound: '智能体不存在',
    taskCreateSuccess: '任务创建成功',
    taskCreateFailed: '任务创建失败',
    taskCreateFailedReason: '任务创建失败：{reason}',
    taskCreateFailedRetry: '任务创建失败，请稍后重试',
    deleteConversationTitle: '确定删除对话？',
    deleteConversationTip: '删除后，聊天记录将不可恢复。',
    confirm: '确定',
    cancel: '取消',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    deleteFailedRetry: '删除失败，请稍后重试',
    pauseTask: '暂停任务',
    resumeTask: '恢复任务',
    stopTaskTitle: '停止任务',
    stopTaskConfirm: '确定要停止这个任务吗？',
    stopped: '任务已停止',
    deleteTaskTitle: '确定删除任务？',
    deleteTaskTip: '删除后，任务将不可恢复。',
    deleted: '任务已删除',
    view: '查看',
    pause: '暂停',
    resume: '恢复',
    stop: '停止',
    delete: '删除',
    reset: '重置',
    interveneTitle: '人工介入',
    interveneConfirm: '确定要进行人工介入吗？',
    interveneStarted: '已启动人工介入，任务继续执行',
    renameEmptyWarn: '请输入对话名称',
    renameSuccess: '重命名成功',
    renameFailed: '重命名失败',
    renameFailedRetry: '重命名失败，请稍后重试',
    pin: '置顶',
    pinSuccess: '置顶成功',
    pinFailed: '置顶失败',
    pinFailedRetry: '置顶失败，请稍后重试',
    labels: {
      taskName: '任务名称',
      recurrence: '运行周期',
      executedCount: '已执行次数',
    },
    terminate: '终止',
    restart: '重启',
    intervene: '人工介入',
    rename: '重命名',
    renameTitle: '修改对话名称',
    renamePlaceholder: '请输入新的对话名称',
  },
  taskDialog: {
    title: '新建任务',
    submit: '提交任务',
    fields: {
      agent: '执行者',
      name: '任务名称',
      desc: '任务说明',
      prompt: '提示词',
      start: '开始时间',
      recurrence: '执行周期',
    },
    labels: {
      repeat: '重复',
      frequency: '频率',
      endsOn: '结束于',
    },
    placeholders: {
      agent: '请选择执行任务的智能体',
      name: '请输入任务名称',
      desc: '可选，用于补充任务目的或上下文',
      prompt: '请输入提示词，例如：请在每小时统计能耗并生成简要报告',
      start: '开始时间',
      date: '选择日期',
      count: '执行次数',
    },
    repeat: {
      once: '不重复',
      tenMin: '每10分钟',
      hour: '每小时',
      daily: '每天',
      weekly: '每周',
      monthly: '每月',
      workday: '工作日',
      custom: '自定义',
    },
    units: {
      minute: '分钟',
      hour: '时',
      day: '天',
      week: '周',
      month: '月',
    },
    endsOn: {
      never: '永不',
      date: '某天',
      count: '次数',
    },
    rules: {
      agent: '请选择执行者',
      name: '请输入任务名称',
      prompt: '请输入提示词',
      start: '请选择开始时间',
    },
    executor: {
      label: '执行者',
      assistant: {
        title: 'AI助手',
        desc: '使用AI助手当前可用的知识与工具',
      },
      selectAgent: {
        title: 'AI员工',
        desc: '调用指定AI员工及其授权能力',
      },
      script: {
        title: '脚本',
        desc: '在隔离容器中按计划运行你的脚本项目',
      },
      selectAgentField: '选择AI员工',
      noTaskCapableAgent: '暂无支持定时任务的AI员工',
      noAssistant: '当前没有可用的AI助手',
    },
    automation: {
      submit: '创建自动流',
      fields: {
        name: '自动流名称',
        desc: '自动流说明',
        prompt: '任务提示词',
        schedule: '调度周期',
      },
      placeholders: {
        name: '例如：每周项目进展汇总',
        desc: '可选，用于补充自动流目的或上下文',
        prompt: '清晰描述自动流要完成的任务、需要读取的信息和期望输出',
        agent: '请选择智能体',
      },
      rules: {
        name: '请输入自动流名称',
        prompt: '请输入任务提示词',
      },
      promptHint: '支持引用日期、用户和运行时间等变量。',
      schedulePreview: '预计下次运行：{datetime}（{period}）',
      schedulePreviewDatetime: '{year}年{month}月{day}日 {time}',
      notifyOnComplete: '运行完成后向我发送通知',
      script: {
        package: '脚本项目包',
        packageChoose: '选择 zip 文件',
        packageEmpty: '未选择文件',
        packageHint: '上传 zip 项目包，解压后即为项目根目录，入口命令在项目根目录下执行',
        packageRequired: '请选择 zip 项目包',
        packageInvalidType: '仅支持 .zip 格式的项目包',
        packageTooLarge: '项目包大小不能超过 {limit} MB',
        entryCommand: '入口命令',
        entryCommandPlaceholder: '例如：python main.py 或 bash run.sh',
        entryCommandRequired: '请输入入口命令',
        timeout: '超时时间（秒）',
        advanced: '高级选项',
        image: '镜像（可选）',
        imagePlaceholder: '留空使用平台默认 runner 镜像',
      },
    },
    validate: {
      endMode: '请选择结束方式（日期或次数）',
      endDate: '请选择结束日期',
      endCount: '请输入有效的结束次数（≥1）',
    },
    frequency: {
      eachN: '每{n}',
    },
  },
  agentHeader: {
    defaultSubtitle: '你的个人AI助手 · 可调用文件、技能库与企业资源',
    supportsTask: '支持任务',
    detail: '详情',
    newChat: '新建对话',
    newTask: '新建任务',
    feedback: '反馈与建议',
    detailTitle: '智能体详情',
    version: '版本',
    currentStatus: '当前状态',
    status: {
      available: '可用',
      disabled: '禁用',
      offline: '离线',
    },
    intro: '简介',
    noDescription: '暂无描述',
    taskCapability: '任务能力',
    scheduledSupported: '支持定时任务',
    scheduledUnsupported: '不支持定时任务',
    stats: {
      instantChat: '即时对话次数:',
      taskExec: '任务执行次数:',
    },
    times: '次',
    feedbackSuccess: '反馈提交成功，感谢您的建议！',
    feedbackFailed: '提交失败，请稍后重试',
    selectAgentFirst: '请先选择智能体',
  },
  taskDetail: {
    title: '执行结果列表',
    runsRecordTitle: '运行记录',
    runsSubtitle: '共 {total} 次运行记录，执行者：{agent}',
    paginationTotal: '共 {total} 条',
    reportDialog: {
      description: '描述：',
      content: '内容：',
      file: '文件：',
      metadata: '元数据：',
      status: '状态：',
      createTime: '创建时间：',
      generateTime: '生成时间：',
      errorMessage: '错误信息：',
      empty: '暂无报告内容',
      close: '关闭',
    },
    brief: {
      name: '任务名称：',
      agentName: '智能体名称：',
      agentStatus: '智能体状态：',
      desc: '任务说明：',
      prompt: '提示词：',
      timeRange: '起止时间：',
      period: '运行周期：',
      executedCount: '已运行次数：',
      status: '任务状态：',
    },
    status: {
      waiting: '等待执行',
      running: '运行中',
      paused: '已暂停',
      terminated: '已终止',
      completed: '已完成',
      abnormal: '异常',
      humanIntervention: '邀请人工',
    },
    actions: {
      feedback: '反馈建议',
      start: '开始执行',
      pause: '暂停任务',
      stop: '终止任务',
      restart: '重启任务',
      reset: '重置',
      delete: '删除任务',
      intervene: '人工介入',
      viewRecord: '查看对话记录',
    },
    confirm: {
      pauseTip: '确定要暂停此任务吗？',
      stopTip: '确定要终止此任务吗？终止后无法恢复。',
      restartTip: '确定要重启此任务吗？',
      deleteTip: '确定要删除此任务吗？删除后无法恢复。',
      interveneTip: '确定要进行人工介入吗？',
    },
    toast: {
      started: '任务已开始执行',
      startFailed: '开始执行失败',
      startFailedRetry: '开始执行失败，请稍后重试',
      paused: '任务已暂停',
      pauseFailed: '暂停任务失败',
      pauseFailedRetry: '暂停任务失败，请稍后重试',
      terminated: '任务已终止',
      stopFailed: '停止任务失败',
      stopFailedRetry: '停止任务失败，请稍后重试',
      restarted: '任务已重启',
      reset: '任务已重置',
      deleted: '任务已删除',
      deleteFailed: '删除任务失败',
      deleteFailedRetry: '删除任务失败，请稍后重试',
      intervene: '已启动人工介入，任务继续执行',
    },
    filter: {
      tagsLabel: '结果标签：',
      tagsPlaceholder: '选择结果标签',
      timeLabel: '时间筛选：',
      rangeSeparator: '至',
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      clearFilters: '清除筛选',
      clearTimeFilter: '清除时间筛选',
      clearTagFilter: '清除标签筛选',
      clearAllFilters: '清除筛选',
      reset: '重置',
    },
    table: {
      id: '执行序号',
      executeTime: '执行时间',
      hasError: '有无异常',
      hasErrorTrue: '有异常',
      hasErrorFalse: '正常',
      duration: '执行时长',
      resultTags: '结果标签',
      conversation: '对话记录',
      conversationId: '对话ID：',
      conversationTip: '提示：',
      conversationTipText: '点击打开对话详情',
      viewConversation: '查看对话记录',
      none: '无',
      report: '执行报告',
      viewReport: '查看报告',
      delete: '删除',
      deleteRecord: '删除执行记录',
      deleteRecordConfirm: '确定要删除这条执行记录吗？',
      recordDeleted: '执行记录已删除',
      downloadFile: '下载文件',
      noErrorMessage: '暂无错误信息',
      reportIdNotExists: '报告ID不存在',
      reportContentEmpty: '报告内容为空',
      getReportFailed: '获取报告内容失败',
      getReportFailedRetry: '获取报告内容失败，请稍后重试',
      executionStatus: {
        success: '正常',
        error: '调用异常',
        failed: '执行异常',
        humanIntervention: '人工介入',
        initial: '初始',
      },
      viewReportTitle: '查看报告',
      errorInfoTitle: '错误信息',
    },
    resetDialog: {
      title: '重置任务',
      timeRange: '起止时间',
      period: '执行周期',
      customPlaceholder: '请输入自定义周期描述',
      tips: '可选粒度：10分钟、小时、日、周；或选择"自定义"并输入描述',
      execCount: '执行次数',
      execCountPlaceholder: '0表示不限制',
      execCountTips: '在时间范围内如果次数满足，任务就终止执行',
      cancel: '取消',
      confirmReset: '确定重置',
    },
    validate: {
      timeRange: '请选择起止时间',
    },
    period: {
      every10m: '每10分钟',
      hourly: '每小时',
      daily: '每日',
      weekly: '每周',
    },
    viewConversation: '查看对话记录',
    agentCannotUse: '当前智能体不可用',
    cannotGetTaskData: '无法获取任务数据，请稍后重试',
    cannotGetAgentId: '无法获取智能体 ID，请稍后重试',
    conversationIdNotExists: '对话 ID 不存在',
    groupSummary: '{timeRange}，应执行 {total} 次，实际执行 {actual} 次，其中 {error} 次异常',
    periodEvery10Min: '每10分钟',
    periodHourly: '每小时',
    periodDaily: '每天',
    periodWeekly: '每周',
  },
  feedbackDialog: {
    title: '反馈与建议',
    rateLabel: '* 请为我们的服务打分',
    suggestionLabel: '* 您的建议',
    placeholder: '请输入您的宝贵建议...',
    submitting: '提交中...',
    submit: '提交反馈',
    submitFailed: '提交失败，请稍后重试',
  },
  platformFeedbackDialog: {
    titleExpert: '评价智能体：{name}',
    titleSkill: '评价技能：{name}',
    defaultTarget: '当前对象',
    description: '评价将发送给管理平台，仅管理人员可查看，用于能力优化和配置沟通。',
    typeLabel: '评价类型',
    ratingLabel: '星级评价',
    contentLabel: '评价内容',
    contentPlaceholder: '请描述使用体验、问题或希望管理人员调整的内容',
    contentHint: '该内容不会公开展示，仅用于与管理人员沟通。',
    contentRequired: '请输入评价内容',
    submitting: '提交中...',
    submit: '提交给管理平台',
    types: {
      experience: '使用体验',
      capability: '能力建议',
      quality: '结果质量',
      permission: '权限或配置问题',
    },
    ratings: {
      5: '★★★★★ 非常满意',
      4: '★★★★☆ 满意',
      3: '★★★☆☆ 一般',
      2: '★★☆☆☆ 需要改进',
      1: '★☆☆☆☆ 不满意',
    },
  },
  notification: {
    tabs: {
      all: '全部',
      unread: '未读',
      read: '已读',
    },
    actions: {
      markRead: '标记已读',
      delete: '删除',
      markAllRead: '全部已读',
      deleteAll: '全部删除',
      close: '关闭',
    },
    table: {
      serialNumber: '序号',
      title: '标题内容',
      status: '状态',
      priority: '优先级',
      sender: '发送者',
      time: '时间',
      type: '类型',
      selectAll: '全选',
      empty: '暂无通知',
    },
    status: {
      read: '已读',
      unread: '未读',
    },
    priority: {
      normal: '普通',
      important: '重要',
      urgent: '紧急',
    },
    type: {
      task: '任务通知',
      email: '邮件通知',
      messageNotification: '消息通知',
      exception: '异常提醒',
      message: '消息提醒',
      event: '事件提醒',
    },
    messages: {
      loading: '加载中...',
      selectToMarkRead: '请选择要标记为已读的通知',
      markSuccess: '标记成功',
      markFailed: '标记失败',
      selectToDelete: '请选择要删除的通知',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      fetchFailed: '获取通知列表失败',
      confirmDelete: '确定要删除选中的通知吗？',
      confirmMarkAllRead: '确定要标记所有通知为已读吗？',
      confirmDeleteAll: '确定要删除所有通知吗？',
      tip: '提示',
    },
    detail: {
      title: '通知详情',
      basicInfo: '基本信息',
      content: '通知内容',
      relatedInfo: '关联信息',
      remark: '备注信息',
      targetUsers: '目标用户',
      fields: {
        id: '通知ID：',
        title: '通知标题：',
        type: '通知类型：',
        priority: '优先级：',
        status: '状态：',
        sender: '发送者：',
        relatedId: '关联ID：',
        relatedType: '关联类型：',
      },
      defaultSender: '系统',
    },
    pagination: {
      total: '共',
      items: '条',
      perPage: '每页',
      itemsUnit: '条',
    },
  },
  login: {
    button: '登录',
    title: '智能体工作台',
    form: {
      username: '请输入用户名',
      password: '请输入密码',
      newPassword: '请输入新密码',
      code: '请输入验证码',
      phone: '请输入手机号',
      phoneInvalid: '请输入正确的手机号',
      confirmPassword: '请确认密码',
      passwordMismatch: '两次输入的密码不一致',
      codeLength: '验证码长度为4位或6位',
      passwordMinLength: '密码长度至少6位',
    },
    actions: {
      login: '登录',
      register: '注册',
      forgotPassword: '忘记密码',
      freeRegister: '免费注册',
      backToLogin: '返回登录',
      hasAccount: '已有账号，',
      getCode: '获取验证码',
      codeSent: '验证码发送成功',
      loginSuccess: '登录成功',
      registerSuccess: '注册成功',
      resetSuccess: '密码重置成功',
      resetPassword: '重置密码',
      captchaFailed: '获取验证码失败，请重试',
      phoneRequired: '请输入手机号',
    },
  },
  logout: {
    title: '退出登录',
    confirmTitle: '确认退出登录？',
    confirmMessage: '退出登录不会丢失任何数据，你仍可以登录此账号。',
    confirmButton: '确认退出',
    cancelButton: '取消',
    success: '退出成功',
  },
  chat: {
    retry: '重试',
    copy: '复制',
    like: '赞',
    dislike: '踩',
    speak: '朗读',
    stopSpeak: '停止播放',
    more: '更多',
    scrollToBottom: '回到底部',
    inputPlaceholder: '请输入内容...',
    emptyTitle: '有什么可以帮你？',
    emptyDescription: '描述你想完成的工作，AI助手会根据需要使用已授权的知识、技能库和连接器。',
    aiNote: 'AI 生成内容仅供参考，请核对重要信息',
    copied: '已复制到剪贴板',
    copyOriginal: '复制原文',
    likeSuccess: '点赞成功',
    likeFailed: '点赞失败',
    dislikeSuccess: '已踩',
    dislikeFailed: '踩踏失败',
    ttsNotSupported: '浏览器不支持语音播报',
    uploadingFile: '正在上传文件...',
    uploadingFiles: '正在上传 {count} 个文件...',
  },
  agentSelector: {
    externalAgent: '外部智能体',
    qrCodeAlt: '{name}二维码',
    qrCodeTip: '请使用微信扫描二维码访问外部智能体',
    welcomeImageAlt: '欢迎图片',
    selectAgentTip: '请选择对应智能体开启对话',
  },
  retrieverResources: {
    title: '引用文件',
    paragraph: '段落 {index}',
    position: '位置:',
    documentId: '文档ID:',
    segmentCount: '段落数量:',
    segmentId: '段落ID:',
  },
  deepThinking: {
    label: '深度思考',
  },
  welcomeText: {
    defaultUsername: '我是 智能体工作台',
  },
  iconSelect: {
    user: '用户',
    building: '建筑',
    business: '办公',
    device: '设备',
    document: '文档',
    system: '系统',
    others: '其他',
    default: '默认',
  },
  filesSelect: {
    missingAgentId: '缺少智能体ID',
    selectAgentFirst: '请先选择或进入一个智能体对话再上传文件',
    uploadFailed: '文件上传失败',
    uploadButton: '上传文件或图片',
    fixUploadError: '存在上传失败的文件，请移除后重新上传',
    dropToUpload: '松开即可上传文件',
    maxFiles: '最多上传 {count} 个文件',
  },
  difyWorkflow: {
    uploadLocal: '从本地上传',
    pasteFileLink: '粘贴文件链接',
    useAttachmentGuide: '请点击附件按钮进入dify工作流处理',
    remoteUrlPlaceholder: '请输入可访问的文件 URL',
    invalidUrl: '请输入以 http:// 或 https:// 开头的链接',
    remove: '移除',
    uploading: '上传中…',
    waitUpload: '文件上传中，请稍后再发送',
    fixUploadError: '存在上传失败的文件，请移除后重新上传',
    fillRequiredFile: '请上传：{name}',
    fillRequiredText: '请填写对话内容',
    noFileInputs: '当前 workflow 未配置文件上传项',
    startRun: '开始运行',
  },
  pageTitle: {
    chat: '智能体工作台',
    login: '登录',
    notification: '消息通知',
    taskDetail: '任务详情',
    notFound: '404页面',
    forbidden: '403页面',
  },

};
